<div class="flex">
    <div class="w-1/3 mr-4">
        <label for="lat-{filterObject.id}">Breitengrad</label>
        <input type="text" id="lat-{filterObject.id}" class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500"
               required placeholder="Wert eingeben"
               on:input={(e) => {onUpdateFilter(filterObject, "lat", e.target.value) }} value="{values.lat}">
    </div>
    <div class="w-1/3 mr-4">
        <label for="lng-{filterObject.id}">Längengrad</label>
        <input type="text" id="lng-{filterObject.id}" class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500"
               required placeholder="Wert eingeben"
               on:input={(e) => {onUpdateFilter(filterObject, "lng", e.target.value) }} value="{values.lng}">
    </div>
    <div class="w-1/3">
        <label for="radius-{filterObject.id}">Radius</label>
        <input type="number" id="radius-{filterObject.id}"
               class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500" required placeholder="Wert eingeben"
               step="0.1" min="0"
               on:input={(e) => {onUpdateFilter(filterObject, "radius", e.target.value) }} value="{values.radius}">
    </div>
</div>


<script>
    import {createEventDispatcher, onMount} from "svelte";

    const dispatch = createEventDispatcher();

    export let filterObject;

    let values = {lat: 0, lng: 0, radius: 0}

    onMount(() => {
        const filterValues = filterObject.getValue();
        const valuesArray = filterValues.split(",");

        if (valuesArray.length === 4) {
            values.lat = valuesArray[0];
            values.lng = valuesArray[1];
            values.radius = valuesArray[3];
        }
    });

    function onUpdateFilter(filterObject, type, value) {
        values[type] = value.replace(/[^0-9,.]/g, "").replace(/,/g, ".");

        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value: `${values.lat},${values.lng},0,${values.radius}`
        });
    }

</script>